/**
 * @license MIT
 * doc-path <https://github.com/mrodrig/doc-path>
 * Copyright (c) 2015-present, Michael Rodrigues.
 */
"use strict";

function evaluatePath(t, r) {
  if (!t) return null;

  var _state = state(r),
      e = _state.dotIndex,
      a = _state.key,
      i = _state.remaining;

  return e >= 0 && !t[r] ? Array.isArray(t[a]) ? t[a].map(function (t) {
    return evaluatePath(t, i);
  }) : evaluatePath(t[a], i) : Array.isArray(t) ? t.map(function (t) {
    return evaluatePath(t, r);
  }) : t[r];
}

function setPath(t, r, e) {
  if (!t) throw new Error("No object was provided.");
  if (!r) throw new Error("No keyPath was provided.");
  return _sp(t, r, e);
}

function _sp(t, r, e) {
  var _state2 = state(r),
      a = _state2.dotIndex,
      i = _state2.key,
      n = _state2.remaining;

  if (r.startsWith("__proto__") || r.startsWith("constructor") || r.startsWith("prototype")) return t;

  if (a >= 0) {
    if (!t[i] && Array.isArray(t)) return t.forEach(function (t) {
      return _sp(t, r, e);
    });
    t[i] || (t[i] = {}), _sp(t[i], n, e);
  } else {
    if (Array.isArray(t)) return t.forEach(function (t) {
      return _sp(t, n, e);
    });
    t[r] = e;
  }

  return t;
}

function state(t) {
  var r = t.indexOf(".");
  return {
    dotIndex: r,
    key: t.slice(0, r >= 0 ? r : void 0),
    remaining: t.slice(r + 1)
  };
}

module.exports = {
  evaluatePath: evaluatePath,
  setPath: setPath
};